import { render, staticRenderFns } from "./Course_info.vue?vue&type=template&id=4bc6ad82"
import script from "./Course_info.vue?vue&type=script&lang=js"
export * from "./Course_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports